import { Card } from "primereact/card";
import React, { useEffect, useState } from "react";
import {
	Button,
	IconButton,
	Modal,
	Tooltip,
} from "../../../../../../components/core";
import CustomTextArea from "../../../../../../components/core/custom-text-area";
import { OrderList } from "primereact/orderlist";
import { MESSAGE_VARIABLES } from "../../../../../../features/coin-campaigns/behavioral-campaign/dropdown";
import { useSelector } from "react-redux";

const BehavioralMessageTemplates = ({
	updatedMessagesFormat,
	setUpdatedMessagesFormat,
	behavioralVars,
	messagesFormat,
	setMessagesFormat,
}) => {
	console.log({ updatedMessagesFormat });
	// local variables
	const [selectedVariable, setSelectedVariable] = useState([]);
	console.log({ selectedVariable });
	const [isEditingInApp, setIsEditingInApp] = useState(false);
	const [isEditingFirstTime, setIsEditingFirstTime] = useState(false);
	const [isEditingSMS2, setIsEditingSMS2] = useState(false);
	const [prevBehavioralVars, setPrevBehavioralVars] = useState({
		smsMessage1: behavioralVars.smsMessage1,
		smsMessage2: behavioralVars.smsMessage2,
		appMessage: behavioralVars.appMessage,
	});
	const [variables, setVariables] = useState(MESSAGE_VARIABLES);
	console.log({});

	const [validation, setValidation] = useState({
		icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
		title: "Invalid data",
		message: "",
		open: false,
		actions: "",
	});

	const accessPermission = useSelector(
		(state) => state.accessPermissions.accessPermissions
	);
	const itemTemplate = (variable) => {
		// console.log({ variable });
		return (
			<div className="p-flex p-ai-center">
				<div>{variable.label}</div>
			</div>
		);
	};

	// Editing message logic
	useEffect(() => {
		if (
			selectedVariable.length > 0 &&
			(isEditingFirstTime || isEditingSMS2 || isEditingInApp)
		) {
			const lastSelectedVariable =
				selectedVariable[selectedVariable.length - 1];

			setUpdatedMessagesFormat((prevState) => ({
				...prevState,
				smsMessage1:
					isEditingFirstTime && !isEditingInApp && !isEditingSMS2
						? prevState.smsMessage1 + " " + lastSelectedVariable
						: prevState.smsMessage1,
				smsMessage2:
					!isEditingFirstTime && !isEditingInApp && isEditingSMS2
						? prevState.smsMessage2 + " " + lastSelectedVariable
						: prevState.smsMessage2,
				appMessage:
					isEditingInApp && !isEditingFirstTime && !isEditingSMS2
						? prevState.appMessage + " " + lastSelectedVariable
						: prevState.appMessage,
			}));
		}
	}, [selectedVariable, isEditingFirstTime, isEditingInApp, isEditingSMS2]);

	return (
		<>
			<div>
				<Card className="bg-[#F8EED4] font-montserrat">
					<div className="px-3 w-full flex flex-col justify-center items-center pb-3">
						<div className="uppercase font-bold text-black tracking-wide text-2xl">
							campaign message templates
						</div>
						<div className="italic font-semibold">
							To insert a variable in the message,{" "}
							<span className="text-red-600 underline">select</span> a variable
							from the list.
						</div>
					</div>

					<div className="grid grid-cols-10 space-x-4">
						<div className="col-span-10">
							<div className="grid grid-cols-12 space-x-4">
								<Card className="col-span-7 bg-secondary-sandGrey">
									<div className="font-bold text-black text-lg  ">
										SMS Message Templates:
									</div>
									<div className=" flex flex-row w-full gap-4">
										<Card className="w-[50%]">
											<div className="flex flex-col gap-2">
												<div className="flex w-full justify-between">
													<label>
														<Tooltip
															icon2={"pi pi-question-circle"}
															className={"pr-1 items-center mt-0"}
															message={
																<div>
																	<p className="indent-5">
																		This message template will be sent to users
																		that earned MBOX coins for the{" "}
																		<span className="font-bold text-orange-400">
																			first time
																		</span>{" "}
																		for this{" "}
																		<span className="font-bold text-orange-400">
																			specific campaign
																		</span>
																	</p>
																</div>
															}
														></Tooltip>
														First Time SMS Message
													</label>

													<IconButton
														icon="pi pi-pencil"
														onClick={() => {
															setIsEditingFirstTime(true);
															setIsEditingInApp(false);
															setIsEditingSMS2(false);
															setSelectedVariable([]);
														}}
														className={`${
															accessPermission.behavioralCampaign === 1 ||
															accessPermission.behavioralCampaign === "1"
																? "hidden"
																: ""
														}`}
													></IconButton>
												</div>

												<div className="w-full">
													{updatedMessagesFormat.smsMessage1?.length > 320 && (
														<div className="text-red-500">
															Maximum character limit reached!
														</div>
													)}
													<CustomTextArea
														placeholder={
															"Congratulations, Juan! You have earned 3 MBOX coins for the first time. Open your MBOX Locker App to view your total MBOX coin balance. Thank you for using MBOX Smart Lockers!"
														}
														value={updatedMessagesFormat.smsMessage1}
														disabled={!isEditingFirstTime}
														className={`w-full min-h-[150px] text-md ${
															updatedMessagesFormat.smsMessage1?.length > 320
																? "border-red-500"
																: ""
														}`}
														onChange={(e) => {
															const newValue = e.target.value;

															setUpdatedMessagesFormat({
																...updatedMessagesFormat,
																smsMessage1: newValue,
															});
														}}
														maxLength={320}
													/>
													{isEditingFirstTime && (
														<>
															<div className="flex justify-start space-x-2">
																<Button
																	value={"Cancel"}
																	className={
																		"p-2 font-normal border bg-white border-primary-primaryYellow px-3"
																	}
																	onClick={() => {
																		setValidation({
																			icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
																			title: "You have made changes",
																			message:
																				"Are you sure you want to stop editing the first time SMS Message? Your changes will not be saved.",
																			open: true,
																			actions: (
																				<div className="grid grid-cols-2 gap-2">
																					<Button
																						onClick={() => {
																							setValidation((prev) => ({
																								...prev,
																								open: false,
																							}));
																						}}
																						value={"No"}
																						className={"p-2"}
																					/>
																					<Button
																						value={"Yes"}
																						className={"p-2"}
																						onClick={() => {
																							setValidation((prev) => ({
																								...prev,
																								open: false,
																							}));

																							setIsEditingFirstTime(false);
																							setUpdatedMessagesFormat({
																								...updatedMessagesFormat,
																								smsMessage1:
																									prevBehavioralVars.smsMessage1,
																							});
																						}}
																					/>
																				</div>
																			),
																		});
																	}}
																></Button>
																<Button
																	value={"Save SMS Message"}
																	disabled={
																		updatedMessagesFormat.smsMessage1.length >
																		320
																	}
																	className={"p-2 px-5"}
																	onClick={() => {
																		setIsEditingFirstTime(false);
																		setMessagesFormat({
																			...messagesFormat,
																			smsMessage1:
																				updatedMessagesFormat.smsMessage1,
																		});
																	}}
																></Button>
															</div>
														</>
													)}
												</div>
											</div>
										</Card>

										{/* sms 2: succeeding earning message */}
										<Card className="w-[50%]">
											<div className="flex flex-col gap-2">
												<div className="flex w-full justify-between">
													<label>
														<Tooltip
															icon2={"pi pi-question-circle"}
															className={"pr-1 items-center mt-0"}
															message={
																<div>
																	<p className="indent-5">
																		This message template will be sent to users
																		for{" "}
																		<span className="font-bold text-orange-400">
																			every 100 MBOX coins
																		</span>{" "}
																		earned.
																	</p>
																</div>
															}
														></Tooltip>
														SMS Message for every 100 MBOX Coins earned
													</label>

													<IconButton
														icon="pi pi-pencil"
														onClick={() => {
															setIsEditingSMS2(true);
															setIsEditingFirstTime(false);
															setIsEditingInApp(false);
															setSelectedVariable([]);
														}}
														className={`${
															accessPermission.behavioralCampaign === 1 ||
															accessPermission.behavioralCampaign === "1"
																? "hidden"
																: ""
														}`}
													></IconButton>
												</div>

												<div className="w-full">
													<CustomTextArea
														placeholder={
															"Congratulations, Juan! You have earned 10 MBOX coins for picking up your parcel within N hours. Thank you for using MBOX Smart Lockers!"
														}
														disabled={!isEditingSMS2}
														value={updatedMessagesFormat.smsMessage2}
														className="w-full min-h-[150px] text-md"
														onChange={(e) => {
															const newValue = e.target.value;

															setUpdatedMessagesFormat((prevState) => ({
																...prevState,
																smsMessage2: newValue,
															}));
														}}
														maxLength={320}
													/>
													{isEditingSMS2 && (
														<>
															<div className="flex justify-start space-x-2">
																<Button
																	value={"Cancel"}
																	className={
																		"p-2 font-normal border bg-white border-primary-primaryYellow px-3"
																	}
																	onClick={() => {
																		setValidation({
																			icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
																			title: "You have made changes",
																			message:
																				"Are you sure you want to stop editing this SMS message? Your changes will not be saved.",
																			open: true,
																			actions: (
																				<div className="grid grid-cols-2 gap-2">
																					<Button
																						onClick={() => {
																							setValidation((prev) => ({
																								...prev,
																								open: false,
																							}));

																							// if (!deleteClicked) {
																							// 	setBehavioralVars((prevState) => ({
																							// 		...prevState,
																							// 		behaviorType: old,
																							// 	}));
																							// }
																						}}
																						value={"No"}
																						className={"p-2"}
																					/>
																					<Button
																						value={"Yes"}
																						className={"p-2"}
																						onClick={() => {
																							setValidation((prev) => ({
																								...prev,
																								open: false,
																							}));

																							setIsEditingSMS2(false);
																							setUpdatedMessagesFormat({
																								...updatedMessagesFormat,
																								smsMessage2:
																									prevBehavioralVars.smsMessage2,
																							});
																						}}
																					/>
																				</div>
																			),
																		});
																	}}
																></Button>
																<Button
																	value={"Save SMS message"}
																	className={"p-2 px-5"}
																	onClick={() => {
																		setIsEditingSMS2(false);
																		setMessagesFormat({
																			...messagesFormat,
																			smsMessage2:
																				updatedMessagesFormat.smsMessage2,
																		});
																	}}
																></Button>
															</div>
														</>
													)}
												</div>
											</div>
										</Card>
									</div>
								</Card>

								<Card className="col-span-3 bg-secondary-sandGrey">
									<div className="font-bold text-black text-lg  ">
										In-app Message Template:
									</div>
									<div className=" flex flex-row w-full gap-4">
										<Card className="w-full">
											<div className="flex flex-col gap-2">
												<div className="flex w-full justify-between">
													<label>
														<Tooltip
															icon2={"pi pi-question-circle"}
															className={"pr-1 items-center mt-0"}
															message={
																<div>
																	<p className="indent-5">
																		This message template will be sent to users{" "}
																		<span className="font-bold text-orange-400">
																			each time they earn coins
																		</span>{" "}
																		for this{" "}
																		<span className="font-bold text-orange-400">
																			campaign
																		</span>{" "}
																		as long as they have the MBOX application
																		installed on their device
																	</p>
																</div>
															}
														></Tooltip>
														In-app message for every coin earned:
													</label>

													<IconButton
														icon="pi pi-pencil"
														onClick={() => {
															setIsEditingInApp(true);
															setIsEditingFirstTime(false);
															setIsEditingSMS2(false);
															setSelectedVariable([]);
														}}
														className={`${
															accessPermission.behavioralCampaign === 1 ||
															accessPermission.behavioralCampaign === "1"
																? "hidden"
																: ""
														}`}
													></IconButton>
												</div>

												<div className="w-full">
													<CustomTextArea
														placeholder={
															"Congratulations, Juan! You have earned 10 MBOX coins for picking up your parcel within N hours. Thank you for using MBOX Smart Lockers!"
														}
														disabled={!isEditingInApp}
														value={updatedMessagesFormat.appMessage}
														className="w-full min-h-[150px] text-md"
														onChange={(e) => {
															const newValue = e.target.value;

															setUpdatedMessagesFormat((prevState) => ({
																...prevState,
																appMessage: newValue,
															}));
														}}
													/>
													{isEditingInApp && (
														<>
															<div className="flex justify-start space-x-2">
																<Button
																	value={"Cancel"}
																	className={
																		"p-2 font-normal border bg-white border-primary-primaryYellow px-3"
																	}
																	onClick={() => {
																		setValidation({
																			icon: `${process.env.PUBLIC_URL}/assets/images/error.png`,
																			title: "You have made changes",
																			message:
																				"Are you sure you want to stop editing the In-App Message? Your changes will not be saved.",
																			open: true,
																			actions: (
																				<div className="grid grid-cols-2 gap-2">
																					<Button
																						onClick={() => {
																							setValidation((prev) => ({
																								...prev,
																								open: false,
																							}));

																							// if (!deleteClicked) {
																							// 	setBehavioralVars((prevState) => ({
																							// 		...prevState,
																							// 		behaviorType: old,
																							// 	}));
																							// }
																						}}
																						value={"No"}
																						className={"p-2"}
																					/>
																					<Button
																						value={"Yes"}
																						className={"p-2"}
																						onClick={() => {
																							setValidation((prev) => ({
																								...prev,
																								open: false,
																							}));

																							setIsEditingInApp(false);
																							setUpdatedMessagesFormat({
																								...updatedMessagesFormat,
																								appMessage:
																									prevBehavioralVars.appMessage,
																							});
																						}}
																					/>
																				</div>
																			),
																		});
																	}}
																></Button>
																<Button
																	value={"Save In-app Message"}
																	className={"p-2 px-5"}
																	onClick={() => {
																		setIsEditingInApp(false);
																		setMessagesFormat({
																			...messagesFormat,
																			appMessage:
																				updatedMessagesFormat.appMessage,
																		});
																	}}
																></Button>
															</div>
														</>
													)}
												</div>
											</div>
										</Card>
									</div>
								</Card>

								<Card className="col-span-2 bg-secondary-sandGrey">
									<div className="col-span-3 h-full">
										<div className="font-bold text-black text-lg  ">
											Variables:
										</div>
										<OrderList
											className="w-full h-full"
											itemTemplate={itemTemplate}
											header=""
											value={variables}
											pt={{
												controls: { className: "hidden" },
											}}
											onClick={(e) => {
												const selectedVariable = e.target.textContent;
												// console.log({ selectedVariable });
												setSelectedVariable((prevSelectedVariables) => [
													...prevSelectedVariables,
													selectedVariable,
												]);
											}}
											// value={MESSAGE_VARIABLES}
										></OrderList>
									</div>
								</Card>
							</div>
						</div>
					</div>
				</Card>
			</div>

			<Modal
				icon={validation.icon}
				title={validation.title}
				message={validation.message}
				open={validation.open}
				actions={validation.actions}
			/>
		</>
	);
};

export default BehavioralMessageTemplates;
